(function () {
  const initAnnBar = () => {
    const annBar = document.querySelector(".section-announcement");
    if (!annBar) return;

    let intersectionObserver;
    let resizeObserver;
    let lastRatio = 1;

    const updateHeight = (intersectionRatio = 1) => {
      const annBarHeight = annBar?.getBoundingClientRect().height || 0;
      const effectiveHeight = (annBarHeight * intersectionRatio).toFixed(2);
      document.documentElement.style.setProperty(
        "--ann-height",
        `${effectiveHeight}px`
      );
    };

    const createObservers = () => {
      if (intersectionObserver) intersectionObserver.disconnect();
      if (resizeObserver) resizeObserver.disconnect();

      intersectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              updateHeight(entry.intersectionRatio);
              lastRatio = entry.intersectionRatio;
            } else {
              document.documentElement.style.setProperty("--ann-height", "0px");
              lastRatio = 0;
            }
          });
        },
        {
          threshold: Array.from({ length: 1000 }, (_, i) => i / 1000),
        }
      );

      resizeObserver = new ResizeObserver(() => {
        updateHeight(lastRatio);
      });

      intersectionObserver.observe(annBar);
      resizeObserver.observe(annBar);
    };

    createObservers();

    // Announcement Fade cycling (every 3 seconds)
    const messages = annBar.querySelectorAll('.announcement-bar__message-item');
    if (messages.length > 1) {
      let currentIndex = 0;
      // Clear any previous interval if already set (for Shopify editor integration)
      if (window.announcementInterval) {
        clearInterval(window.announcementInterval);
      }
      window.announcementInterval = setInterval(() => {
        messages[currentIndex].classList.remove('active');
        currentIndex = (currentIndex + 1) % messages.length;
        messages[currentIndex].classList.add('active');
      }, 3000);
    }
  };

  document.addEventListener("shopify:section:load", initAnnBar);
  document.addEventListener("shopify:section:unload", () => {
    if (window.announcementInterval) {
      clearInterval(window.announcementInterval);
    }
  });
  document.addEventListener("shopify:section:reorder", initAnnBar);

  initAnnBar();
})();
